import { render, staticRenderFns } from "./UploadAvatarImage.vue?vue&type=template&id=11afd5e3&scoped=true&"
import script from "./UploadAvatarImage.vue?vue&type=script&lang=js&"
export * from "./UploadAvatarImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadAvatarImage.vue?vue&type=style&index=0&id=11afd5e3&lang=scss&scoped=true&"
import style1 from "./UploadAvatarImage.vue?vue&type=style&index=1&id=11afd5e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11afd5e3",
  null
  
)

export default component.exports